import { z } from 'zod';


/**
 * Zod schema for shift change request form validation
 * Validates dates and comment length according to backend requirements
 */
export const shiftRequestSchema = z.object({
  dateFrom: z
    .string({
      required_error: 'attendance:shiftChange.validation.dateFromRequired',
    })
    .min(1, 'attendance:shiftChange.validation.dateFromRequired')
    .regex(
      /^\d{4}-\d{2}-\d{2}$/,
      'attendance:shiftChange.validation.dateFormat',
    ),
  
  dateTo: z
    .string({
      required_error: 'attendance:shiftChange.validation.dateToRequired',
    })
    .min(1, 'attendance:shiftChange.validation.dateToRequired')
    .regex(
      /^\d{4}-\d{2}-\d{2}$/,
      'attendance:shiftChange.validation.dateFormat',
    ),
  
  requesterComment: z
    .string()
    .max(500, 'attendance:shiftChange.validation.commentMaxLength')
    .optional()
    .or(z.literal('')),
}).refine(
  (data) => {
    const from = new Date(data.dateFrom + 'T00:00:00');
    const to = new Date(data.dateTo + 'T00:00:00');
    return from <= to;
  },
  {
    message: 'attendance:shiftChange.validation.dateFromBeforeTo',
    path: ['dateTo'],
  },
).refine(
  (data) => {
    // Parse date in local timezone (YYYY-MM-DD format)
    const fromDate = new Date(data.dateFrom + 'T00:00:00');
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return fromDate >= today;
  },
  {
    message: 'attendance:shiftChange.validation.dateFromNotPast',
    path: ['dateFrom'],
  },
).refine(
  (data) => {
    // Parse dates in local timezone
    const fromDate = new Date(data.dateFrom + 'T00:00:00');
    const toDate = new Date(data.dateTo + 'T00:00:00');
    const diffInDays = Math.ceil((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24));
    return diffInDays <= 30;
  },
  {
    message: 'attendance:shiftChange.validation.dateRangeMax',
    path: ['dateTo'],
  },
);

export type ShiftRequestFormData = z.infer<typeof shiftRequestSchema>;
